import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CataloguePlansService {

  constructor(private http: HttpClient) { }


  getByEventName(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE_PLANS.GET_BY_EVENT_NAME + '?eventName=' + dataIn.eventName;

    return this.http.get(url);

  }


}
